import React, { memo, useEffect, useState } from 'react';

import { useIsFocused } from '@react-navigation/native';

import { useIsNativeTabBarEnabled } from 'hooks/use-is-native-tab-bar-enabled';
import ClassicTabsLayout from 'navigation/layouts/classic-tabs-layout';
import NativeTabsLayout from 'navigation/layouts/native-tabs-layout';

function TabsLayoutGate() {
  const isTabsFocused = useIsFocused();
  const isNativeTabBarEnabled = useIsNativeTabBarEnabled();

  // iOS 26's native Liquid Glass tab bar permanently corrupts its label-width layout (only a
  // tab press fixes it) if its first native attach happens while the "(tabs)" screen isn't
  // focused - e.g. on a deep link that pushes a screen on top of it before this screen ever
  // becomes the visible one. So NativeTabsLayout's first mount specifically requires LIVE focus,
  // not just "was focused at some earlier point" - a full-screen route can cover tabs before this
  // screen ever mounts natively, and in that case it must keep waiting. `hasNativeTabsMounted`
  // then latches that decision so a later blur (e.g. opening a cart modal) never unmounts the
  // already-attached tab bar and resets its navigator state.
  const [hasNativeTabsMounted, setHasNativeTabsMounted] = useState(false);
  const shouldRenderNativeTabs = isNativeTabBarEnabled && (hasNativeTabsMounted || isTabsFocused);

  useEffect(() => {
    if (shouldRenderNativeTabs) {
      setHasNativeTabsMounted(true);
    }
  }, [shouldRenderNativeTabs]);

  if (isNativeTabBarEnabled && !shouldRenderNativeTabs) {
    return null;
  }

  return isNativeTabBarEnabled ? <NativeTabsLayout /> : <ClassicTabsLayout />;
}

export default memo(TabsLayoutGate);
